import { StatusBar } from "expo-status-bar";
import React from "react";
import { useState, useRef } from "react";
import { useTheme, useNavigation } from "@react-navigation/native";
import { CustomTheme } from "../../../../styles/theme.style";
import { StyleSheet, Text, View, Image } from "react-native";
import commonStyles from "../../../../styles/common.style";
import Loading from "../../../components/Loading";
import BackgroundContainer from "../../../components/BackgroundContainer";

import { Button } from "../../../components/Button";
import InputField from "../../../components/InputField";
import ErrorMessage from "../../../components/ErrorMessage";
import { auth } from "../../../../config/firebase";
import i18n from "i18n-js";



export default function LoginScreen() {
  const { appColors }: CustomTheme = useTheme() as CustomTheme;
  const navigation = useNavigation();

  const [isLoading, setIsLoading] = React.useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisibility, setPasswordVisibility] = useState(true);
  const [rightIcon, setRightIcon] = useState("eye");
  const [loginError, setLoginError] = useState("");

  const refPwInput = useRef();
  const refSubmitButton = useRef();

  const handlePasswordVisibility = () => {
    if (rightIcon === "eye") {
      setRightIcon("eye-off");
      setPasswordVisibility(!passwordVisibility);
    } else if (rightIcon === "eye-off") {
      setRightIcon("eye");
      setPasswordVisibility(!passwordVisibility);
    }
  };

  const onLogin = async () => {
    try {
      if (email !== "" && password !== "") {
        setIsLoading(true);
        await auth
          .signInWithEmailAndPassword(email, password)
          .then((userCredential: any) => {
            setIsLoading(false);
          });
      }
    } catch (error: any) {
      setLoginError(error.message);
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Loading></Loading>;
  }

  return (
    <BackgroundContainer>
      <View style={styles.container}>
        <StatusBar style="auto" />
        <Image
          style={styles.logo}
          source={require("../../../../assets/brand/logo_claim/PONGATE_Logo-Claim_460x180.png")}
        />
        {/*<Text style={[appColors.text, commonStyles.headingText, styles.title]}>
          {i18n.t("Authentication.Login_Screen.Title")} 
        </Text>*/}
        <View style={styles.form}>
          <InputField
            style={styles.inputStyle}
            containerStyle={styles.inputContainerStyle}
            leftIcon="email"
            placeholder={i18n.t("Authentication.Email_Placeholder")}
            autoCapitalize="none"
            keyboardType="email-address"
            textContentType="emailAddress"
            autoFocus={true}
            value={email}
            blurOnSubmit={false}
            onChangeText={(text: string) => setEmail(text)}
            onSubmitEditing={() =>
              refPwInput.current && refPwInput.current.focus()
            }
          />
          <InputField
            style={styles.inputStyle}
            containerStyle={styles.inputContainerStyle}
            leftIcon="lock"
            placeholder={i18n.t("Authentication.Password_Placeholder")}
            autoCapitalize="none"
            autoCorrect={false}
            secureTextEntry={passwordVisibility}
            textContentType="password"
            rightIcon={rightIcon}
            value={password}
            onChangeText={(text: string) => setPassword(text)}
            onRightIconClick={handlePasswordVisibility}
            blurOnSubmit={false}
            innerRef={refPwInput}
            onSubmitEditing={() => {
              //refSubmitButton.current && refSubmitButton.current.focus()
              return;
            }}
          />
          {loginError ? (
            <ErrorMessage error={loginError} visible={true} />
          ) : null}
          <Button
            onPress={onLogin}
            title={i18n.t("Authentication.Login")}
            style={styles.loginButton}
            innerRef={refSubmitButton}
          />
          <Button
            onPress={() => navigation.navigate("Signup")}
            style={styles.signUpButton}
            title={
              i18n.t("Authentication.Login_Screen.No_Account") +
              " " +
              i18n.t("Authentication.Sign_Up")
            }
          />
        </View>
      </View>
    </BackgroundContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 0,
    paddingHorizontal: 12,
    maxWidth: 500,
    width: "100%",
    alignSelf: "center",
  },
  form: {
    marginTop: 12,
  },
  title: {
    fontSize: 24,
    fontWeight: "600",
    alignSelf: "center",
    paddingBottom: 24,
  },
  inputStyle: {
    fontSize: 14,
  },
  inputContainerStyle: {
    backgroundColor: "#fff",
    marginBottom: 20,
  },
  loginButton: {
    marginBottom: 10,
  },
  signUpButton: {
    backgroundColor: "transparent",
    shadowRadius: 0,
    elevation: 0,
    shadowOffset: { height: 0, widht: 0 },
  },
  logo: {
    //flex: 1,
    height: 180,
    width: undefined,
    resizeMode: "contain",
  },
});
